import { Page, SelectFilter } from '@/components';
import {
  EtherScanPictogram,
  Heading,
  useTableProps,
  Flex
} from '@blockanalitica/ui';
import EventsTable from './EventsTable';
import { TREASURY_OPERATIONS } from '@/constants';
import { useMemo } from 'react';
import HistoricTabs from './HistoricTabs';
export default function TreasuryEventsPage() {
  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All events', value: '' }];
    options.push(
      ...Object.entries(TREASURY_OPERATIONS).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.operation
      }))
    );
    return options;
  }, [filters]);
  return (
    <Page
      title={
        <Heading size="1">
          <Flex gap="xs">
            Treasury
            <a
              href={`https://etherscan.io/address/0xbe8e3e3618f7474f8cb1d074a26affef007e98fb`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="0" />
            </a>
          </Flex>
        </Heading>
      }>
      <HistoricTabs />
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignContent="center"
        alignItems="center">
        <Heading size="3">Events</Heading>
        <SelectFilter
          key="operation-filter"
          filterField="operation"
          options={selectFilterOptions}
          {...filters}
        />
      </Flex>
      <EventsTable
        pagination={pagination}
        sorting={sorting}
        filters={filters}
      />
    </Page>
  );
}
